import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const LogoTextLight: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="346"
      height="173"
      viewBox="0 0 346 173"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_4_5)">
        <path
          d="M2.84351 58.4775L3.60551 54.2628H24.426C25.95 54.2628 26.583 53.9958 26.7823 52.8811L27.3802 49.5605C27.3802 49.456 27.4154 49.3283 27.4154 49.2354C27.4154 48.4458 26.8175 48.144 25.481 48.144H11.4835C6.70044 48.144 4.8013 46.4256 4.8013 43.7319C4.8013 43.372 4.87162 42.9424 4.93024 42.5128L5.19988 40.9337C5.7626 37.5782 8.32996 35.3025 13.7813 35.3025H34.0273L33.3004 39.4824H13.0544C11.6242 39.4824 10.827 39.8423 10.6277 40.8989L10.3346 42.5476C10.2995 42.6405 10.2995 42.7798 10.2995 42.8727C10.2995 43.6274 10.8974 43.9641 12.2572 43.9641H26.2548C31.0378 43.9641 32.937 45.7057 32.937 48.3762C32.937 48.7709 32.9018 49.1657 32.8432 49.5953L32.2453 52.8231C31.6123 56.1786 29.1504 58.4891 23.664 58.4891H2.84351V58.4775Z"
          fill="#141621"
        />
        <path
          d="M45.317 58.4776C40.5574 58.4776 38.6699 56.7361 38.6699 54.1004C38.6699 53.7057 38.7403 53.3109 38.7989 52.8813L40.9325 40.8874C41.5304 37.5551 43.9923 35.291 49.4436 35.291H65.3051C70.0647 35.291 71.9287 37.0326 71.9287 39.6683C71.9287 40.063 71.8935 40.4578 71.8349 40.8874L69.7013 52.8813C69.1034 56.2136 66.6415 58.4776 61.1902 58.4776H45.317ZM66.4305 40.8293C66.4305 39.9121 65.9967 39.4825 64.5665 39.4825H48.705C47.3451 39.4825 46.5479 39.9121 46.3721 40.8293L44.215 52.9161C44.1798 53.009 44.1798 53.1135 44.1798 53.1832C44.1798 53.9379 44.8481 54.2746 46.079 54.2746H61.9405C63.3004 54.2746 64.0976 53.8798 64.2734 52.9277L66.4305 40.8293Z"
          fill="#141621"
        />
        <path
          d="M83.0303 49.2936L81.4008 58.4776H75.9846L80.1112 35.291H104.789L104.062 39.4709H84.8122L83.8157 45.1021H101.705L100.943 49.282H83.0303V49.2936Z"
          fill="#141621"
        />
        <path
          d="M118.013 58.4776L121.401 39.4709H109.326L110.053 35.291H139.384L138.657 39.4709H126.852L123.464 58.4776H118.013Z"
          fill="#141621"
        />
        <path
          d="M169.758 58.4776L164.975 41.9091L154.002 58.4776H150.04L143.287 35.291H148.375L153.1 51.8595L163.944 35.291H168L172.783 51.8595L183.521 35.291H188.914L173.85 58.4776H169.758Z"
          fill="#141621"
        />
        <path
          d="M211.071 58.4776L202.889 40.8293L188.152 58.4776H181.998L201.716 35.291H205.702L217.074 58.4776H211.071Z"
          fill="#141621"
        />
        <path
          d="M244.318 58.4776L240.93 48.1673H229.629L227.8 58.4776H222.384L226.511 35.291H246.862C251.622 35.291 253.509 37.0326 253.509 39.7031C253.509 40.063 253.474 40.4578 253.415 40.8874L253.111 42.5709C252.618 45.3343 250.918 47.5403 246.628 48.0977L250.016 58.4776H244.318ZM247.976 40.8293C247.976 39.9121 247.542 39.4825 246.112 39.4825H231.176L230.379 43.9991H245.315C246.745 43.9991 247.448 43.732 247.648 42.6174L247.976 40.8293Z"
          fill="#141621"
        />
        <path
          d="M256.932 58.4776L261.059 35.291H285.736L285.009 39.4709H265.76L264.928 44.1152H283.145L282.383 48.3299H264.166L263.134 54.2629H282.383L281.621 58.4776H256.932Z"
          fill="#141621"
        />
        <path
          d="M2.53857 98.012L6.66517 74.8254H28.6462C34.3671 74.8254 36.4656 76.4741 36.4656 79.7368C36.4656 80.3289 36.3952 80.9907 36.2663 81.6758L34.543 91.3939C33.781 95.7364 31.3191 98.012 24.5313 98.012H2.53857ZM30.815 81.6758C30.8853 81.2462 30.9439 80.8862 30.9439 80.5844C30.9439 79.2723 30.1116 79.0053 27.9193 79.0053H11.3545L8.72843 93.7974H25.2933C27.9897 93.7974 28.7517 93.4026 29.1151 91.3243L30.815 81.6758Z"
          fill="#141621"
        />
        <path
          d="M40.6272 98.012L44.7538 74.8254H69.4311L68.7042 79.0053H49.4548L48.6224 83.6496H66.8403L66.0783 87.8643H47.8604L46.8287 93.7974H66.0783L65.3163 98.012H40.6272Z"
          fill="#141621"
        />
        <path
          d="M79.1968 88.8168L77.5673 98.0009H72.1511L76.2777 74.8142H100.955L100.228 78.9941H80.9787L79.9822 84.6253H97.8719L97.1099 88.8051H79.1968V88.8168Z"
          fill="#141621"
        />
        <path
          d="M102.479 98.012L106.605 74.8254H112.021L107.895 98.012H102.479Z"
          fill="#141621"
        />
        <path
          d="M144.612 98.012L123.299 80.7933L120.24 98.012H115.515L119.642 74.8254H124.331L143.756 90.9644L146.652 74.8254H151.412L147.285 98.012H144.612Z"
          fill="#141621"
        />
        <path
          d="M154.694 98.012L158.82 74.8254H183.498L182.771 79.0053H163.521L162.689 83.6496H180.907L180.145 87.8643H161.927L160.895 93.7974H180.145L179.383 98.012H154.694Z"
          fill="#141621"
        />
        <path
          d="M186.23 98.012L190.356 74.8254H212.337C218.058 74.8254 220.157 76.4741 220.157 79.7368C220.157 80.3289 220.087 80.9907 219.958 81.6758L218.234 91.3939C217.472 95.7364 215.01 98.012 208.223 98.012H186.23ZM214.495 81.6758C214.565 81.2462 214.624 80.8862 214.624 80.5844C214.624 79.2723 213.791 79.0053 211.599 79.0053H195.034L192.408 93.7974H208.973C211.669 93.7974 212.431 93.4026 212.795 91.3243L214.495 81.6758Z"
          fill="#141621"
        />
        <path
          d="M29.4432 137.535L21.2604 119.886L6.52432 137.535H0.369629L20.0881 114.348H24.074L35.4455 137.535H29.4432Z"
          fill="#141621"
        />
        <path
          d="M68.1888 114.348H73.6049L70.4748 131.938C69.877 135.27 67.4151 137.535 61.9638 137.535H47.0284C42.2688 137.535 40.3813 135.793 40.3813 133.157C40.3813 132.763 40.4517 132.368 40.5103 131.938L43.6404 114.348H49.0566L45.9264 131.973C45.8913 132.066 45.8913 132.17 45.8913 132.24C45.8913 132.995 46.5595 133.331 47.7904 133.331H62.7258C64.0857 133.331 64.8829 132.937 65.0587 131.985L68.1888 114.348Z"
          fill="#141621"
        />
        <path
          d="M87.4852 137.535L90.8732 118.528H78.7983L79.5252 114.348H108.857L108.13 118.528H96.3245L92.9365 137.535H87.4852Z"
          fill="#141621"
        />
        <path
          d="M117.215 137.535C112.456 137.535 110.568 135.793 110.568 133.157C110.568 132.763 110.638 132.368 110.697 131.938L112.831 119.944C113.429 116.612 115.89 114.348 121.342 114.348H137.203C141.963 114.348 143.827 116.089 143.827 118.725C143.827 119.12 143.792 119.515 143.733 119.944L141.599 131.938C141.002 135.27 138.54 137.535 133.088 137.535H117.215ZM138.329 119.886C138.329 118.969 137.895 118.539 136.465 118.539H120.603C119.243 118.539 118.446 118.969 118.27 119.886L116.113 131.973C116.078 132.066 116.078 132.17 116.078 132.24C116.078 132.995 116.746 133.331 117.977 133.331H133.839C135.199 133.331 135.996 132.937 136.172 131.985L138.329 119.886Z"
          fill="#141621"
        />
        <path
          d="M179.372 137.535L181.962 122.917L168.399 137.535H163.944L155.491 122.94L152.901 137.535H147.883L152.01 114.348H156.863L167.133 132.298L183.697 114.348H188.516L184.389 137.535H179.372Z"
          fill="#141621"
        />
        <path
          d="M218.75 137.535L210.567 119.886L195.831 137.535H189.677L209.395 114.348H213.381L224.752 137.535H218.75Z"
          fill="#141621"
        />
        <path
          d="M234.846 137.535L238.234 118.528H226.159L226.886 114.348H256.217L255.49 118.528H243.685L240.297 137.535H234.846Z"
          fill="#141621"
        />
        <path
          d="M258.327 137.535L262.454 114.348H267.87L263.744 137.535H258.327Z"
          fill="#141621"
        />
        <path
          d="M278.714 137.535C273.954 137.535 272.067 135.793 272.067 133.157C272.067 132.763 272.137 132.368 272.196 131.938L274.329 119.944C274.927 116.612 277.389 114.348 282.841 114.348H298.702C303.462 114.348 305.326 116.089 305.326 118.725C305.326 119.12 305.29 119.515 305.232 119.944L303.098 131.938C302.5 135.27 300.039 137.535 294.587 137.535H278.714ZM299.827 119.886C299.827 118.969 299.394 118.539 297.964 118.539H282.102C280.742 118.539 279.945 118.969 279.769 119.886L277.612 131.973C277.577 132.066 277.577 132.17 277.577 132.24C277.577 132.995 278.245 133.331 279.476 133.331H295.337C296.697 133.331 297.495 132.937 297.67 131.985L299.827 119.886Z"
          fill="#141621"
        />
        <path
          d="M338.479 137.535L317.166 120.304L314.106 137.535H309.382L313.508 114.348H318.197L337.623 130.487L340.518 114.348H345.278L341.151 137.535H338.479Z"
          fill="#141621"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_5">
          <rect
            width="346"
            height="103"
            fill="white"
            transform="translate(0 35)"
          />
        </clipPath>
      </defs>
    </BaseIcon>
  );
};

LogoTextLight.displayName = 'LogoTextLight';
